import * as common from './common'
import env from '../../common/helpers/env'
import * as mVoucher from './voucher_M'
//FLH2D Move 2D Table To YXYWeb
const voucher = function () {
  const renderData = function (billNo, viewModel, params) {
    render(viewModel, params.data, params.dirty, true);
  }
  const render = (viewmodel, data, dirty) => {
    common.setRenderReadOnly(viewmodel)
    if (dirty) {
      viewmodel.setDirty(true)
      viewmodel.loadDirtyData(data)
      // common.getGridModel(viewmodel) && common.getGridModel(viewmodel).initRowState(cb.models.DataStates.Insert)
      const gridModels = viewmodel.getGridModels();
      gridModels.forEach(gridModel => {
        gridModel.initRowState(cb.models.DataStates.Insert);
        // PromotionGroup组件的模型存储在表格模型的cache的editRowModels里
        const editRowmodels = gridModel.getCache('editRowModels');
        if (cb.utils.isArray(editRowmodels)) {
          editRowmodels.forEach((model) => {
            if (model instanceof cb.models.ContainerModel) {
              const editGridModels = model.getGridModels();
              editGridModels.forEach((editGridModel) => {
                editGridModel.initRowState(cb.models.DataStates.Insert);
              });
            }
          });
        }
      });
    } else {
      viewmodel.loadData(data)
    }
    common.setState(viewmodel)
    viewmodel.execute('afterLoadData', data);
    // && gridModel.t2DInfo_Bus_IsShow2D() == false
    // && gridModel.t2DInfo_Bus_IsShow2D() == false
  }

  const _reloadVoucher = (bSwitchTpl, data, viewmodel, billNo, afterAct, resetMode) => {
    if (bSwitchTpl) {
      let vmParams = {
        tplid: data.tplid
      }
      vmParams.billData = data
      let cbk = function (err, meta) {
        const reloadVoucherCallback = (vm, view) => {
          viewmodel.communication({
            payload: {
              menuName: view.cBillName,
              vm: vm,
              refresh: true,
              metaData: view
            }
          })
        }
        _fetchMetaCallback(err, meta, billNo, reloadVoucherCallback, vmParams)
      }
      common.fetchMeta(billNo, vmParams, cbk)
    } else {
      _resetData(viewmodel, data, afterAct, resetMode)
    }
  }

  const _doService = (billNo, viewmodel, params, beforeAct, afterAct) => {
    common.doService(billNo, viewmodel, params, beforeAct, afterAct, _doServiceByData)
  }

  const _doServiceByData = (viewmodel, postData, params, afterAct) => {
    let callback = function (err, res) {
      if (!err) {
        cb.utils.alert(`${params.cShowCaption}成功`, 'success')
        let oldData = viewmodel.collectData(true)
        let newData = common.billMerge(oldData, res)
        render(viewmodel, newData)
      }
      let afterActData = {
        err: err,
        res: res
      }
      if (afterAct) afterAct(afterActData, common.afterAct)
    }
    common.doProxy(params, callback, postData)
  }

  const _tplIsEquql = (data, viewmodel) => {
    let result = false
    if (!viewmodel.get(env.VOUCHER_TPL_KEY)) {
      result = false
    } else {
      if (data[env.VOUCHER_TPL_KEY] != viewmodel.get(env.VOUCHER_TPL_KEY).getValue()) {
        result = true
      } else {
        result = false
      }
    }
    return result
  }

  const _resetData = (viewmodel, data, afterAct, resetMode) => {
    if (resetMode !== false)
      common.setMode(viewmodel, env.VOUCHER_STATE_BROWSE)
    render(viewmodel, data)
    if (!afterAct) return
    afterAct({
      res: data
    }, common.afterAct)
  }

  const _loadVm = function (oldVM, newVM) {
    newVM.originalVM = oldVM.originalVM
    newVM.originalViewMeta = oldVM.originalViewMeta
    newVM.biz.do('rule', newVM)
    newVM.biz.do('initDefaultActions', newVM)
  }

  const _fetchMetaCallback = function (err, meta, billNo, viewCallback, params) {
    const extendCallback = (vm, view) => {
      vm.viewCallback = viewCallback
      vm.originalVM = vm
      vm.originalParams = params
      vm.originalViewMeta = meta.viewmeta
      let data = {
        vm,
        view
      }
      vm.promiseExecute('afterLoadMeta', data, function () {
        let title = (view.view && view.view.cTemplateTitle) || view.cBillName;
        switch (params.mode) {
          case env.VOUCHER_STATE_ADD:
            title = '新增' + title;
            break;
          case env.VOUCHER_STATE_EDIT:
            title = '编辑' + title;
            break;
          case env.VOUCHER_STATE_BROWSE:
            if (!title.includes('详情'))
            title += '详情';
            break;
        }
        viewCallback(vm, view, title) //先绑定view防止extend中 viewmode addProperty
        const gridModels = vm.getGridModels();
        gridModels.forEach(gridModel => {
          gridModel.on('afterSetDataSource', () => {
            const afterAct = gridModel.getCache('afterAct');
            if (afterAct)
              afterAct();
            common.setGridActionStates(gridModel, vm, vm.getParams().mode);
          });
          gridModel.on('afterMount', () => {
            common.setGridActionStates(gridModel, vm, vm.getParams().mode);
          });
          gridModel.on('afterInsertRow', () => {
            common.setGridActionStates(gridModel, vm, vm.getParams().mode);
          });
          gridModel.on('afterInsertRows', () => {
            common.setGridActionStates(gridModel, vm, vm.getParams().mode);
          });
          // vm.on('afterEdit', () => {
          //   common.setGridActionStates(gridModel, vm, vm.getParams().mode);
          // });
        });
        const { billData } = vm.getParams();
        vm.biz.do('load', vm, {
          data: billData
        })
        vm.biz.do('rule', vm)
        if (params.copy)
          vm.biz.do('copy', vm);
      })


    }
    const backRefresh = (vm) => {
      const params = Object.assign(vm.getParams(), { mode: env.VOUCHER_STATE_EDIT, id: vm.get('id').getValue() }); // fangqg: 临时删除 mode: env.VOUCHER_STATE_EDIT,
      _getInitdata(billNo, params, function (err, billData) {
        if (err) {
          cb.utils.alert(err.message, 'error');
          return;
        }
        _resetData(vm, billData);
      });
    }
    const vmAndView = common.initVM(err, meta, billNo, params, extendCallback)
    if (vmAndView) {
      let { vm, view } = vmAndView
      vm.setCache('entryMode', params.mode);
      vm.initData()
      common.setMode(vm, params.mode);
      // vm.setCache('entryMode', params.mode);
      vm.on('refresh', function () {
        backRefresh(vm);
      });
      vm.on('back', function () {
        if (common.getMode(vm) !== env.VOUCHER_STATE_BROWSE) return;
        backRefresh(vm);
      });
      const returnPromise = new cb.promise();
      vm.on('return', function (caption) {
        if (common.getMode(vm) === env.VOUCHER_STATE_BROWSE || !vm.getDirtyData(false))
          return true;
        // returnSave(billNo, vm, function () {
        //   returnPromise.resolve();
        //   const parentViewModel = vm.getCache('parentViewModel');
        //   if (parentViewModel)
        //     parentViewModel.execute('refresh');
        // });
        // return returnPromise;
        cb.utils.confirm(`确定要${caption}么`, function () {
          returnPromise.resolve();
        }, function () {
          returnPromise.reject();
        });
        return returnPromise;
      });
      // common.setRenderReadOnly(vm)
      vm.biz.do('initDefaultActions', vm)
      if (params.mode === env.VOUCHER_STATE_EDIT)
        vm.execute('afterEdit');
    }
  }

  const _getInitdata = function (billNo, params, callback, beforeAct) {
    const proxy = cb.rest.DynamicProxy.create({ getCmdList: { url: 'billmeta/getbillcommands', method: 'GET' } });
    proxy.getCmdList({ billno: billNo }, function (err, result) {
      let postData = {
        "billnum": billNo
      }
      let cmdName, cSvcUrl, cHttpMethod
      let mode = params && params.mode || env.VOUCHER_STATE_BROWSE
      if (mode === env.VOUCHER_STATE_BROWSE && params && params.readOnly) {
        // 浏览态卡片刷新当前页面需要重置mode
        mode = env.VOUCHER_STATE_EDIT;
      }
      switch (mode) {
        case env.VOUCHER_STATE_ADD:
          cmdName = 'cmdadd';
          cSvcUrl = 'bill/add'
          cHttpMethod = 'POST'
          Object.assign(postData, params.carryParams);
          break
        case env.VOUCHER_STATE_EDIT:
          cmdName = 'cmddetail';
          cSvcUrl = 'bill/detail'
          cHttpMethod = 'GET'
          if (!params.id) {
            callback();
            return;
          }
          postData.id = params.id
          if (params.isSum)
            postData.isSum = params.isSum;
          Object.assign(postData, params.carryParams);
          break
        case env.VOUCHER_STATE_BROWSE:
          cmdName = 'cmdenter';
          cSvcUrl = 'bill/enter'
          cHttpMethod = 'GET'
          postData.subid = params && params.subId
          break
      }
      if (cmdName && result) {
        const configParams = result.find(x => {
          return x.cCommand && x.cCommand.trim().toLocaleLowerCase() === cmdName;
        });
        if (configParams && configParams.cSvcUrl) {
          cSvcUrl = configParams.cSvcUrl;
          cHttpMethod = configParams.cHttpMethod || 'GET'
        }
      }
      if (params && params.readOnly === true) {
        params.mode = env.VOUCHER_STATE_BROWSE
      }
      let par = {
        cSvcUrl: cSvcUrl,
        cHttpMethod: cHttpMethod
      }
      let beforeActData = {
        params: params,
        data: postData
      }
      if (beforeAct) {
        beforeAct(beforeActData, function () {
          common.doProxy(par, callback, postData)
        })
      } else {
        common.doProxy(par, callback, postData)
      }
    });
  }

  const cellCheck = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let gridModel = common.getGridModel(viewmodel, params)
    let cellName = params.cellName
    let column = gridModel.getColumn(cellName)
    let data = {
      location: params.rowIndex,
      key: cellName,
      childrenField: params.childrenField,
      value: JSON.stringify(params.value),
      type: column.cControlType,
      fieldname: column.cFieldName,
      title: params.title,
      async: params.async
    }
    let beforeActData = {
      params: params,
      data: data
    };
    beforeAct(beforeActData, function () {
      if (column.bCheck === true) {
        const ruleItems = gridModel.getCache('ruleItems');
        if (ruleItems && ruleItems.indexOf(cellName) > -1)
          data.async = false;
        common.check(billNo, viewmodel, data, beforeAct, afterAct, true)
      }

    })

  }

  const lineOpenOrClose = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewmodel, params).getSelectedRowIndexes();
    if (!rowIndexes.length) {
      return
    }
    // let selectData = common.getGridModel(viewmodel, params).getSelectedRows()
    let selectData = common.getGridModel(viewmodel, params).getRowsByIndexes(rowIndexes)
    let index = rowIndexes[0]
    let childrenField = common.getGridModel(viewmodel, params).getName()
    let data = viewmodel.collectData(true)
    data[childrenField] = selectData
    let postData = {
      billnum: billNo,
      data: JSON.stringify(data)
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      let callback = function (err, res) {
        if (!err) {
          cb.utils.alert('操作成功', 'success')
          const condition = {};
          if (params && params.childrenField)
            condition[params.childrenField] = [index];
          let oldData = viewmodel.collectData(true)
          let newData = common.billMerge(oldData, res, condition)
          render(viewmodel, newData)
          common.getGridModel(viewmodel, params).select([index])
        }
        let afterActData = {
          err: err,
          res: res
        }
        afterAct(afterActData, common.afterAct)
      }
      common.doProxy(params, callback, postData)
    })

  }

  const copy1 = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let callback = function (err, res) {
      let newData
      if (!err) {
        let oldData = viewmodel.collectData(true)
        //lastData = cb.utils.extend(true, {}, oldData)
        newData = common.billMerge(oldData, res)
        common.setMode(viewmodel, env.VOUCHER_STATE_ADD)
        render(viewmodel, newData, true)
      }
      let afterActData = {
        err: err,
        res: newData
      }
      afterAct(afterActData, common.afterAct)
    }
    let postData = {
      "billnum": billNo
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      common.emptyBill(postData, params, callback)
    })

  }

  const copy = function (billNo, viewModel, params, beforeAct, afterAct) {
    if (viewModel) {
      common.copy(viewModel, params, viewModel.get('id').getValue(), beforeAct, afterAct);
      return;
    }
    if (!params || !params.cSvcUrl) return;
    const callback = function (err, emptyData) {
      if (err) {
        common.afterAct({ err });
        return;
      }
      _getInitdata(billNo, params, function (err1, copyData) {
        if (err1) {
          common.afterAct({ err1 });
          return;
        }
        params.mode = 'add';
        afterAct(null, common.billCopy(copyData, emptyData));
      });
    };
    const postData = { billnum: billNo };
    common.doProxy(params, callback, postData);
  }

  const refresh = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let refreshCallback = function (err, billData) {
      if (!err && billData) {
        const bSwitchTpl = _tplIsEquql(billData, viewmodel)
        _reloadVoucher(bSwitchTpl, billData, viewmodel, billNo, afterAct)
      } else {
        let afterActData = {
          err: err,
          res: billData
        }
        afterAct(afterActData, common.afterAct)
      }

    }
    let pm = {
      mode: env.VOUCHER_STATE_EDIT,
      id: viewmodel.get('id').getValue(),
      isSum: params && params.isSum
    }
    let beforeActData = {
      params: params,
      data: pm
    };
    beforeAct(beforeActData, function () {
      _getInitdata(billNo, pm, refreshCallback, beforeAct)
    })
  }

  const loadData = (billNo, viewmodel, para, beforeAct, afterAct) => {
    let data = para.data// || {}
    let mode = common.getMode(viewmodel)
    const action = common.getVmParams(viewmodel, 'action');
    let parent = common.getVmParams(viewmodel, 'parent')
    let cCarry = common.getVmParams(viewmodel, 'cCarry')
    let carryKeys = []
    if (cCarry && parent) {
      try {
        cCarry = JSON.parse(cCarry)
      } catch (error) {
        console.error('列表cCarry JSON格式错误-->' + cCarry)
        return
      }

      if (typeof (cCarry) === 'object') {
        for (let key in cCarry) {
          let value = cCarry[key]
          data[key] = parent[value]
          carryKeys.push(key)
        }
      }
    }
    //携带需要setdirty true  否则保存不收集
    carryKeys.map(key => {
      let model = viewmodel.get(key)
      if (model) {
        model.setDirty(true)
      }
    })
    let beforeActData = {
      params: para,
      data: data
    }
    beforeAct(beforeActData, function () {
      render(viewmodel, data, mode == env.VOUCHER_STATE_ADD);
    })


  }

  const buildRule = (billNo, viewmodel, para, beforeAct, afterAct) => {
    let postData = {
      billNumber: billNo,
      language: 'javascript'
    }
    let beforeActData = {
      params: para,
      data: postData
    }
    beforeAct(beforeActData, function () {
      common.doProxy({
        cSvcUrl: '/itemrule/script',
        cHttpMethod: 'GET'
      }, function (err, data) {
        data = eval(data)
        data.rules.forEach(function (rule) {
          var fields = {}
          rule.triggers.forEach(function (trigger) {
            var fieldName = trigger.ds
            if (fieldName) {
              if (!fields[fieldName])
                fields[fieldName] = []
              fields[fieldName].push(trigger.item)
            } else {
              if (!viewmodel.get(trigger.item)) return
              viewmodel.get(trigger.item).on('afterValueChange', function () {
                this.run(this.param)
              }, {
                  run: data.run,
                  param: {
                    ruleid: rule.id,
                    vm: viewmodel,
                    trigger: {
                      ds: fieldName,
                      item: trigger.item,
                      lineid: '0'
                    }
                  }
                })
            }
          })
          for (var attr in fields) {
            if (!viewmodel.get(attr)) continue
            viewmodel.get(attr).setCache('ruleItems', fields[attr]);
            viewmodel.get(attr).on('afterCellValueChange', function (args) {
              if (this.items.indexOf(args.cellName) === -1) return
              this.param.trigger.item = args.cellName
              this.param.trigger.lineid = '0:' + args.rowIndex
              this.run(this.param)
            }, {
                items: fields[attr],
                run: data.run,
                param: {
                  ruleid: rule.id,
                  vm: viewmodel,
                  trigger: {
                    ds: attr
                  }
                }
              })
            // fangqg: 删行后重新执行公式计算
            viewmodel.get(attr).on('afterDeleteRows', function () {
              var childrenField = this.childrenField;
              this.items.forEach(function (cellName) {
                viewmodel.get(childrenField).execute('afterCellValueChange', { rowIndex: -1, cellName });
              });
            }, {
                items: fields[attr],
                childrenField: attr
              });
          }
        })
        var jointFields = {}
        data.jointFields.forEach(function (field) {
          var fieldName = field.ds
          if (fieldName) {
            if (!jointFields[fieldName])
              jointFields[fieldName] = []
            jointFields[fieldName].push(field.item)
          } else {
            if (!viewmodel.get(field.item)) return
            viewmodel.get(field.item).on('jointQuery', function () {
              let config = null;
              try {
                config = JSON.parse(this.param.vm.get(this.param.trigger.item).getState('cStyle'));
              } catch (e) {
                config = {};
              }
              let queryData = this.jointQuery(this.param)
              const items = [];
              for (var attr in queryData.paras) {
                items.push(attr + '=' + queryData.paras[attr]);
              }
              config.menuCode = 'SJ0201';
              if (config.menuCode) {
                viewmodel.communication({ type: 'menu', payload: { menuCode: config.menuCode, menuUrl: '?' + items.join(',') } });
                return;
              }
              let parent = this.param.vm
              let dt = {
                billtype: 'voucher',
                billno: queryData.target,
                params: cb.utils.extend(true, queryData.paras, {
                  mode: env.VOUCHER_STATE_EDIT
                })
              }
              cb.loader.runCommandLine('bill', dt, parent)
            }, {
                jointQuery: data.jointQuery,
                param: {
                  vm: viewmodel,
                  trigger: {
                    ds: field.ds,
                    item: field.item
                  }
                }
              })
          }
        })
        for (var attr in jointFields) {
          if (!viewmodel.get(attr)) continue
          viewmodel.get(attr).on('cellJointQuery', function (args) {
            if (this.items.indexOf(args.cellName) === -1) return
            this.param.trigger.item = args.cellName
            this.param.trigger.lineid = '0:' + args.rowIndex
            let queryData = this.jointQuery(this.param)
            let parent = this.param.vm
            let dt = {
              billtype: 'voucher',
              billno: queryData.target,
              params: cb.utils.extend(true, queryData.paras, {
                mode: env.VOUCHER_STATE_EDIT
              })
            }
            cb.loader.runCommandLine('bill', dt, parent)
          }, {
              items: jointFields[attr],
              jointQuery: data.jointQuery,
              param: {
                vm: viewmodel,
                trigger: {
                  ds: attr
                }
              }
            })
        }
        var refFields = {}
        data.refFields.forEach(function (field) {
          var fieldName = field.ds
          if (fieldName) {
            if (!refFields[fieldName])
              refFields[fieldName] = []
            refFields[fieldName].push(field.item)
          } else {
            var referModel = viewmodel.get(field.item);
            if (!referModel) return
            referModel.on('beforeBrowse', function () {
              let queryData = this.jointQuery(this.param)
              if (!queryData) return
              _setReferRule(queryData, this.referModel)
            }, {
                referModel: referModel,
                jointQuery: data.jointQuery,
                param: {
                  action: 'ref',
                  vm: viewmodel,
                  trigger: {
                    ds: field.ds,
                    item: field.item
                  }
                }
              })
          }
        })
        for (var attr in refFields) {
          var referModel = viewmodel.get(attr);
          if (!referModel) continue
          referModel.on('beforeBrowse', function (args) {
            if (this.items.indexOf(args.cellName) === -1) return
            this.param.trigger.item = args.cellName
            this.param.trigger.lineid = '0:' + args.rowIndex
            let queryData = this.jointQuery(this.param)
            if (!queryData) return
            _setReferRule(queryData, args.context)
          }, {
              referModel: referModel,
              items: refFields[attr],
              jointQuery: data.jointQuery,
              param: {
                action: 'ref',
                vm: viewmodel,
                trigger: {
                  ds: attr
                }
              }
            })
        }

        afterAct()
      }, postData)
    })

  }
  const _setReferRule = (queryData, referModel) => {
    var target = queryData.target
    if (target) {
      if (target.cRefType) {
        referModel.setRefCode(target.cRefType)
      }
      if (target.cRefRetId) {
        referModel.setReturnFields(cRefRetId.refid)
      }
    }
    referModel.setFilter({
      isExtend: true,
      simpleVOs: queryData.paras
    })
  }

  const _resetOriginal = (viewmodel, afterAct) => {
    let newVM = viewmodel.originalVM
    if (newVM.get(env.VOUCHER_TPL_KEY) && viewmodel.get(env.VOUCHER_TPL_KEY) && (newVM.getOriginalData()[env.VOUCHER_TPL_KEY] != viewmodel.get(env.VOUCHER_TPL_KEY).getValue())) {
      viewmodel.communication({
        payload: {
          menuName: newVM.originalViewMeta.cBillName,
          vm: newVM,
          refresh: true,
          metaData: newVM.originalViewMeta
        }
      })
      _loadVm(viewmodel, newVM)
    }
    if (!viewmodel.getParams().menuId)
      common.setMode(newVM, env.VOUCHER_STATE_BROWSE)
    let newData = newVM.getOriginalData()
    if (newVM.get(env.VOUCHER_TPL_KEY) && !newData[env.VOUCHER_TPL_KEY]) {
      newData[env.VOUCHER_TPL_KEY] = newVM.get(env.VOUCHER_TPL_KEY).get('cDefaultValue')
    }
    render(newVM, newData)
    let afterActData = {
      res: newData
    }
    afterAct(afterActData, common.afterAct)
  }

  const abandon = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let beforeActData = {
      params: params
    }
    beforeAct(beforeActData, function () {
      let mode = common.getMode(viewmodel);
      if (mode === env.VOUCHER_STATE_BROWSE && !viewmodel.getParams().menuId) {
        viewmodel.communication({ type: 'return' });
        return;
      }
      const data = viewmodel.getDirtyData(false);
      if (!data) {
        _abandon(viewmodel, afterAct);
        return;
      }
      cb.utils.confirm(`确定要${params.cShowCaption}么`, function () {
        _abandon(viewmodel, afterAct);
      }, function () {
        if (params && params.enabledCallback)
          params.enabledCallback();
      });
      return;
      returnSave(billNo, viewmodel, _abandon);
    });
  }
  const _abandon = function (viewmodel, afterAct) {
    if (viewmodel.getParams().multitpl || viewmodel.getCache('entryMode') !== env.VOUCHER_STATE_BROWSE && !viewmodel.getParams().menuId) {
      viewmodel.communication({ type: 'return', payload: false });
      return;
    }
    _resetOriginal(viewmodel, afterAct);
    viewmodel.validate(true);
  }
  const returnSave = function (billNo, viewModel, closeCallback) {
    cb.utils.confirm('是否保存？', function () {
      save(billNo, viewModel, null, function (beforeActData, callback) {
        return viewModel.promiseExecute('beforeSave', beforeActData, callback);
      }, function () {
        closeCallback(viewModel);
      });
    }, function () {
      closeCallback(viewModel);
    });
  }
  const inValid = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let invalidReason = prompt("请输入作废理由", "")
    let data = viewmodel.getNecessaryData()
    if (invalidReason) {
      data = cb.utils.extend(data, {
        invalidReason
      })
    }
    let postData = {
      billnum: billNo,
      data: JSON.stringify(data)
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {

      _doServiceByData(viewmodel, postData, params, afterAct)
    })
  }

  const submit = (billNo, viewmodel, params, beforeAct, afterAct) => {
    console.log('submit --->')
    let data = viewmodel.collectData(true)
    let postData = {
      billnum: billNo,
      data: JSON.stringify(data)
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {

      _doServiceByData(viewmodel, postData, params, afterAct)
    })


  }

  const checkApprove = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let postData = {
      billNum: billNo,
      billId: viewmodel.get('id'),
      billCode: viewmodel.get('code')
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      viewmodel.communication({
        type: 'modal',
        payload: {
          type: 'platform',
          url: 'checkapprove',
          model: viewmodel,
          data: postData
        }
      })
      afterAct()
    })

  }

  const audit = (billNo, viewmodel, params, beforeAct, afterAct) => {
    if (viewmodel.get("isWfControlled") && viewmodel.get("isWfControlled").getValue()) {
      let postData = {
        billNum: billNo,
        billId: viewmodel.get('id'),
        billCode: viewmodel.get('code')
      }
      let beforeActData = {
        params: params,
        data: postData
      }
      beforeAct(beforeActData, function () {
        viewmodel.communication({
          type: 'modal',
          payload: {
            type: 'platform',
            url: 'approve',
            model: viewmodel,
            data: postData
          }
        })
        afterAct()
      })

    } else {
      let data = viewmodel.collectData(true)
      let postData = {
        billnum: billNo,
        data: JSON.stringify(data)
      }
      let beforeActData = {
        params: params,
        data: postData
      }
      beforeAct(beforeActData, function () {

        _doServiceByData(viewmodel, postData, params, afterAct)
      })
    }

  }

  const close = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let data = viewmodel.collectData(true)
    let postData = {
      billnum: billNo,
      data: JSON.stringify(data)
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      _doServiceByData(viewmodel, postData, params, afterAct)
    })

  }

  const table2DBtnClick = function (billNo, viewmodel, params, beforeAct, afterAct) {
    viewmodel.execute('table2DBtnClick');
  }

  const addRow = function (billNo, viewmodel, params, beforeAct, afterAct) {
    // viewmodel.communication({
    //   type: 'modal',
    //   payload: {
    //     key: 'openTable2D',
    //     data: {
    //       billNo: billNo,
    //       gridModel: common.getGridModel(viewmodel, params),
    //       params: params
    //     }
    //   }
    // });
    // return;
    let gridModel = common.getGridModel(viewmodel, params);
    let support2D = gridModel.t2DInfo_Bus_Get("support2D");
    let show2D = gridModel.t2DInfo_Bus_Get("show2D");
    if (support2D && show2D) {
      viewmodel.execute('table2DAddRowClick');
    }
    else {
      let beforeActData = {
        params: params
      }
      beforeAct(beforeActData, function () {
        let data = common.getGridModel(viewmodel, params).appendRow()
        afterAct(data)
      })
    }
  }

  const deleteRow = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewmodel, params).getSelectedRowIndexes();
    let beforeActData = {
      params: params,
      data: rowIndexes
    }
    beforeAct(beforeActData, function () {
      let data = common.getGridModel(viewmodel, params).deleteRows(rowIndexes)
      afterAct(data)
    })

  }

  const insertRow = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewmodel, params).getSelectedRowIndexes();
    let beforeActData = {
      params: params,
      data: rowIndexes
    }
    beforeAct(beforeActData, function () {
      if (!rowIndexes.length) {
        return
      }
      let data = common.getGridModel(viewmodel, params).insertRow(rowIndexes[0])
      afterAct(data)
    })

  }

  const copyRow = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewmodel, params).getSelectedRowIndexes();
    if (!rowIndexes.length) {
      return
    }
    let rowData = common.getGridModel(viewmodel, params).getSelectedRows()
    let beforeActData = {
      params: params,
      data: {
        rowIndexes,
        rowData
      }
    }
    beforeAct(beforeActData, function () {
      let data = common.getGridModel(viewmodel, params).insertRow(rowIndexes[0], rowData[0])
      afterAct(data)
    })

  }

  const shiftUpRow = function (billNo, viewModel, params, beforeAct, afterAct) {
    const rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewModel, params).getSelectedRowIndexes();
    if (!rowIndexes.length) return;
    const rowIndex = rowIndexes[0];
    const args = {
      params: params,
      data: rowIndex
    };
    beforeAct(args, function () {
      common.getGridModel(viewModel, params).shiftUpRow(rowIndex);
      afterAct(args);
    });
  };

  const shiftDownRow = function (billNo, viewModel, params, beforeAct, afterAct) {
    const rowIndexes = params && params.params && params.params.index != null ?
      [params.params.index] :
      common.getGridModel(viewModel, params).getSelectedRowIndexes();
    if (!rowIndexes.length) return;
    const rowIndex = rowIndexes[0];
    const args = {
      params: params,
      data: rowIndex
    };
    beforeAct(args, function () {
      common.getGridModel(viewModel, params).shiftDownRow(rowIndex);
      afterAct(args);
    });
  };

  const localPrint = function (billNo, viewModel, params, beforeAct, afterAct) {
    params = params || {};
    if (!params.cAction) {
      const configParams = viewModel.allActions && viewModel.allActions.find(item => {
        return item.cAction.trim().toLocaleLowerCase() === 'localprint';
      });
      Object.assign(params, configParams);
    }
    const id = viewModel.get('id').getValue();
    if (cb.utils.isEmpty(id)) {
      cb.utils.alert('未找到具体单据', 'error');
      return;
    }
    const route = params && params.cSvcUrl || '/bill';
    const { disabledCallback, enabledCallback } = params;
    const templatesModel = viewModel.get('templates');
    if (templatesModel) {
      const templateCode = templatesModel.getValue();
      if (cb.utils.isEmpty(templateCode)) {
        cb.utils.alert('请选择打印模板', 'error');
        return;
      }
      if (disabledCallback) {
        disabledCallback();
        params.disabledCallback = false;
      }
      _localPrint(billNo, templateCode, id, route, beforeAct, enabledCallback);
    } else {
      if (disabledCallback) {
        disabledCallback();
        params.disabledCallback = false;
      }
      const proxy = cb.rest.DynamicProxy.create({
        getTemplate: { url: 'print/getTemplateByBo', method: 'GET', options: { mask: true } }
      });
      proxy.getTemplate({ billno: billNo }, function (err, data) {
        if (err) {
          cb.utils.alert(err.message, 'error');
          if (enabledCallback)
            enabledCallback();
          return;
        }
        const template = data.length === 1 ? data[0] : data.find(item => {
          return item.isdefault;
        });
        if (cb.utils.isEmpty(template)) {
          cb.utils.alert('没有设置打印模板，请检查', 'error');
          if (enabledCallback)
            enabledCallback();
          return;
        }
        _localPrint(billNo, template.templatecode, id, route, beforeAct, enabledCallback);
      });
    }
  }

  const _localPrint = function (billno, templateCode, id, route, beforeAct, enabledCallback) {
    const proxy = cb.rest.DynamicProxy.create({
      print: { url: route + '/getTemplateStructure', method: 'POST', options: { mask: true } }
    });
    const params = { billno, templateCode, ids: [id] };
    proxy.print(params, function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        if (enabledCallback)
          enabledCallback();
        return;
      }
      beforeAct(result, function () {
        cb.utils.localPrint(result);
        if (enabledCallback)
          enabledCallback();
      });
    });
  }
  const isInWorkBench = function (model) {
    let bReturn = false;
    const key = 'isInWorkBench';
    bReturn = isModelHasKey(model, key);
    if (model && bReturn == false) {
      model = model.getParent();
      bReturn = isModelHasKey(model, key);
    }
    if (model && bReturn == false) {
      model = model.getParent();
      bReturn = isModelHasKey(model, key);
    }
    return bReturn;
  }
  const isHideAlert = function (model) {
    let bReturn = false;
    let key = "isHideAlert";
    bReturn = isModelHasKey(model, key);
    if (model && bReturn == false) {
      model = model.getParent();
      bReturn = isModelHasKey(model, key);
    }
    if (model && bReturn == false) {
      model = model.getParent();
      bReturn = isModelHasKey(model, key);
    }
    return bReturn || false;
  }

  const isModelHasKey = function (model, key) {
    return (model && (model.getCache(key) == true)) || false;
  }

  const save = function (billNo, viewmodel, params, beforeAct, afterAct, caption) {
    params = params || {};
    if (!params.cAction) {
      const configParams = viewmodel.allActions && viewmodel.allActions.find(item => {
        return item.cAction.trim().toLocaleLowerCase() === 'save';
      });
      Object.assign(params, configParams);
    }
    const invalidMsg = viewmodel.validate();
    if (invalidMsg) {
      cb.utils.alert('以下数据项校验失败：' + invalidMsg.join(','), 'error');
      return;
    }
    let mode = common.getMode(viewmodel)
    const action = common.getVmParams(viewmodel, 'action');
    /*幂等校验 yxGuid*/
    if(viewmodel.get('yxGuid')) {
      const yxGuid = viewmodel.get('yxGuid').getValue();
      if(!yxGuid) viewmodel.get('yxGuid').setValue(cb.utils.getNewGuid());
    }

    let data = viewmodel.collectData()
    if (!data) {
      cb.utils.alert('未作任何修改')
      viewmodel.setReadOnly(true)
      common.setState(viewmodel)
      return
    }
    if (common.getVmParams(viewmodel, 'metatype') && common.getVmParams(viewmodel, 'metatype') == 'editablevoucherlist') {
      data = data[viewmodel.getGridModel().getName()]
    }
    if (mode == env.VOUCHER_STATE_ADD) {
      data['_status'] = cb.models.DataStates.Insert
      let parentId = common.getVmParams(viewmodel, 'parentId') //树表新建时的父类
      if (parentId != undefined) {
        let key = common.getVmParams(viewmodel, 'foreignKey') //档案的parentid
        if (key) {
          data[key] = parentId
        }
      }
    } else {
      data["_status"] = cb.models.DataStates.Update
    }

    let postData = Object.assign({
      billnum: billNo,
      data: JSON.stringify(data)
    }, params.defineParams);
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      let callback = function (err, res) {
        // if (err) {
        //   cb.utils.alert(err.message, 'error');
        //   return;
        // }
        let newData = res;
        let afterActData = {
          params,
          err: err,
          res: newData
        }
        if (!err) {
          // cb.utils.alert(`${caption || '保存'}成功`, 'success')
          viewmodel.setDirty(false);//解决保存的时候，出现弹框的问题
          if (isHideAlert(viewmodel) == false) {
            const content = `${caption || '保存'}成功`;
            if (window.parent !== window && cb.rest.AppContext.query.random)
              window.parent.postMessage({ key: 'crossdomainpush', random: cb.rest.AppContext.query.random, msg: { type: 'success', content } }, '*');
            else
              cb.utils.alert(content, 'success')
          }
          /* 生单工作台 */
          if (isInWorkBench(viewmodel) == true) {
            afterAct(afterActData, common.afterAct);
            return
          }
          const { menuId, saveReturn } = viewmodel.getParams();
          if (!menuId || saveReturn === false)
            common.setMode(viewmodel, env.VOUCHER_STATE_BROWSE);
          else if (menuId && mode === env.VOUCHER_STATE_ADD)
            common.setMode(viewmodel, env.VOUCHER_STATE_EDIT);
          const currentAction = params.cAction.trim().toLocaleLowerCase();
          if (currentAction === 'saveandadd') {
            afterAct(afterActData, common.afterAct);
            return/*保存并新增*/
          }
          if (currentAction !== 'saveandaudit' && saveReturn !== false && (viewmodel.getParams().multitpl || viewmodel.getCache('entryMode') !== env.VOUCHER_STATE_BROWSE) && !menuId) {
            if (cb.utils.isEmpty(viewmodel.get('id').getValue()) && res)
              viewmodel.get('id').setValue(res.id);
            afterAct(afterActData, common.afterAct);
            viewmodel.communication({ type: 'return', payload: viewmodel.get('id').getValue() });
            return;
          }
          // common.setMode(viewmodel, env.VOUCHER_STATE_BROWSE)
          let oldData = viewmodel.collectData(true)
          let condition;
          let arrayKeys = []
          for (let key in res) {
            if (Array.isArray(res[key]) && viewmodel.get(key) && viewmodel.get(key).getDirtyRowIndexes && viewmodel.get(key).getDirtyRowIndexes() && viewmodel.get(key).getDirtyRowIndexes().length > 0) {
              arrayKeys.push(key)
              condition = {};
            }
          }

          arrayKeys.forEach((key) => {
            condition[key] = viewmodel.get(key).getDirtyRowIndexes()
          })
          newData = common.billMerge(oldData, res, condition)

          Object.values(newData).forEach((ele) => {
            if (ele instanceof Array) {
              ele.forEach((row) => {
                if (row && row.hasOwnProperty("_status")) {
                  row["_status"] = cb.models.DataStates.Unchanged;
                }
              })
            }
          })
          
          render(viewmodel, newData)
        }
        // let afterActData = {
        //   params,
        //   err: err,
        //   res: newData
        // }
        afterAct(afterActData, common.afterAct)
      }
      params.options = { mask: true };
      common.doProxy(params, callback, postData)
    })

  }

  const doDelete = function (billNo, viewmodel, params, beforeAct, afterAct) {

    let data = viewmodel.getNecessaryData()
    let postData = {
      billnum: billNo,
      data: JSON.stringify(data)
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      const text = viewmodel.getParams().caption;
      cb.utils.confirm(`是否确认删除此${text}`, function () {
        common.doProxy(params, function (err, suc) {
          if (!err) {
            cb.utils.alert('操作成功', 'success')
            viewmodel.communication({ type: 'return' });
            // viewmodel.execute('moveprev')
          }
          let afterActData = {
            err: err,
            res: suc
          }
          afterAct(afterActData, common.afterAct)
        }, postData)
      }, function () {
        if (params && params.enabledCallback)
          params.enabledCallback();
      })
    });
  }

  const moveFirstOrLast = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let postData = {
      billnum: billNo
    }
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      let callback = function (err, res) {
        if (!err) {
          render(viewmodel, res)
        }
        let afterActData = {
          err: err,
          res: res
        }
        afterAct(afterActData, common.afterAct)
      }
      common.doProxy(params, callback, postData)
    })

  }

  const movePrevOrNext = function (billNo, viewmodel, params, beforeAct, afterAct) {
    let postData = {
      billnum: billNo
    }
    let listCondition = null
    // params.cHttpMethod = "POST";
    try {
      if (JSON.parse(params.cmdParameter).needCondition)
        listCondition = viewmodel.getCache("parentViewModel").getCache("lastSearchCondition").condition
    } catch(e){ console.error(e)} finally {
      postData.condition = listCondition
    }
    cb.utils.extend(postData, viewmodel.getNecessaryData())
    let beforeActData = {
      params: params,
      data: postData
    }
    beforeAct(beforeActData, function () {
      let callback = function (err, res) {
        if (!err) {
          const bSwitchTpl = _tplIsEquql(res, viewmodel)
          _reloadVoucher(bSwitchTpl, res, viewmodel, billNo, afterAct)
        } else {
          let afterActData = {
            err: err,
            res: res
          }
          afterAct(afterActData, common.afterAct)
        }

      }
      common.doProxy(params, callback, postData)
    })

  }



  //拉单
  const pull = (billNo, viewmodel, params, beforeAct, afterAct) => {
    var queryString = new cb.utils.queryString(params.cSvcUrl)
    let targetCode = queryString.get('code')
    let targetBillNo = queryString.get('targetBillNo')
    if (targetCode && targetBillNo) {
      let queryData = {
        code: targetCode,
        isMainSelect: 1,
        childIds: [viewmodel.get('id').getValue()]
      }
      let par = {
        cSvcUrl: queryString.pathname + queryString.toStr(),
        cHttpMethod: params.cHttpMethod
      }
      let beforeActData = {
        params: params,
        data: queryData
      }
      beforeAct(beforeActData, function () {
        let callback = function (err, data) {
          if (!err) {
            let params = {
              mode: env.VOUCHER_STATE_ADD,
              carryData: data
            }
            let dt = {
              billtype: 'voucher',
              billno: targetBillNo,
              params: params
            }
            cb.loader.runCommandLine('bill', dt, viewmodel)
          }
          let afterActData = {
            err: err,
            res: data
          }
          afterAct(afterActData, common.afterAct)

        }
        common.doProxy(par, callback, queryData)
      })

    }
  }
  const saveAndAdd = (billNo, viewModel, params) => {
    let saveParams = viewModel.allActions && viewModel.allActions.find(item => {
      return item.cAction.trim().toLocaleLowerCase() === 'save';
    });
    if (!saveParams) {
      cb.utils.alert('没有取到保存参数', 'error');
      return;
    }
    saveParams = Object.assign({}, saveParams, { cAction: params.cAction });
    const beforeSave = (beforeActData, callback) => {
      viewModel.promiseExecute('beforeSave', beforeActData, callback);
    };
    const afterSave = (afterActData, callback) => {
      viewModel.promiseExecute('afterSave', afterActData, function () {
        callback && callback(afterActData);
      });
    };
    save(billNo, viewModel, saveParams, beforeSave, function (afterSaveData) {
      afterSave(afterSaveData, function () {
        if (afterSaveData.err) {
          common.afterAct(afterSaveData);
          return;
        }
        let addParams = viewModel.allActions && viewModel.allActions.find(item => {
          return item.cAction.trim().toLocaleLowerCase() === 'add';
        });
        // if (!addParams) {
        //   cb.utils.alert('没有取到提交参数', 'error');
        //   return;
        // }
        addParams = Object.assign({}, addParams, { cAction: params.cAction });
        const beforeAdd = (beforeActData, callback) => {
          viewModel.promiseExecute('beforeAdd', beforeActData, callback);
        };
        const afterAdd = (afterActData, callback) => {
          viewModel.promiseExecute('afterAdd', afterActData, function () {
            callback && callback(afterActData);
          });
        };
        add(billNo, viewModel, addParams, beforeAdd, afterAdd);
      });
    });
  }
  const saveAndAudit = (billNo, viewModel, params) => {
    let saveParams = viewModel.allActions && viewModel.allActions.find(item => {
      return item.cAction.trim().toLocaleLowerCase() === 'save';
    });
    if (!saveParams) {
      cb.utils.alert('没有取到保存参数', 'error');
      return;
    }
    saveParams = Object.assign({}, saveParams, { cAction: params.cAction });
    const beforeSave = (beforeActData, callback) => {
      viewModel.promiseExecute('beforeSave', beforeActData, callback);
    };
    const afterSave = (afterActData, callback) => {
      viewModel.promiseExecute('afterSave', afterActData, function () {
        callback && callback(afterActData);
      });
    };
    save(billNo, viewModel, saveParams, beforeSave, function (afterSaveData) {
      afterSave(afterSaveData, function () {
        if (afterSaveData.err) {
          common.afterAct(afterSaveData);
          return;
        }
        let auditParams = viewModel.allActions && viewModel.allActions.find(item => {
          return item.cAction.trim().toLocaleLowerCase() === 'audit';
        });
        if (!auditParams) {
          cb.utils.alert('没有取到提交参数', 'error');
          return;
        }
        auditParams = Object.assign({}, auditParams, { cAction: params.cAction });
        const beforeAudit = (beforeActData, callback) => {
          viewModel.promiseExecute('beforeAudit', beforeActData, callback);
        };
        const afterAudit = (afterActData, callback) => {
          viewModel.promiseExecute('afterAudit', afterActData, function () {
            callback && callback(afterActData);
          });
        };
        audit(billNo, viewModel, auditParams, beforeAudit, afterAudit);
      });
    });
  }
  const add = (billNo, viewmodel, params, beforeAct, afterAct) => {
    if (!viewmodel) {
      return _getInitdata(billNo, params, afterAct);
      const { cSvcUrl, cHttpMethod } = params.params;
      const callback = function (err, emptyData) {
        if (err) {
          common.afterAct({ err });
          return;
        }
        afterAct(null, emptyData);
      };
      const postData = Object.assign({ billnum: billNo }, params.carryParams);
      common.doProxy({ cSvcUrl, cHttpMethod }, callback, postData);
      return;
    }
    params = params || {};
    if (!params.cAction) {
      const configParams = viewmodel.allActions && viewmodel.allActions.find(item => {
        return item.cAction.trim().toLocaleLowerCase() === 'add';
      });
      Object.assign(params, configParams);
    }
    var queryString = new cb.utils.queryString(params.cSvcUrl)
    var callbackdata = []
    if (queryString.has('code')) {
      let dt = {
        billtype: 'billmaker',
        billno: queryString.get('billno'),
        params: {
          'code': queryString.get('code'),
          'makeBilltype': queryString.get('makeBilltype')
        }
      }
      cb.loader.runCommandLine('bill', dt, null, function (vm, viewmeta) {
        var callback = function (err, suc) {
          callbackdata = suc
          let afterActData = {
            err: err,
            res: suc
          }
          afterAct(afterActData, common.afterAct)
        }
        let postData = {
          "billnum": billNo
        }
        let beforeActData = {
          params: params,
          data: postData
        };
        beforeAct(beforeActData, function () {
          common.emptyBill(postData, params, callback)
          vm.on('afterOkClick', function (args) {
            if (args.data) {
              common.setMode(viewmodel, env.VOUCHER_STATE_ADD)
              var newdata = common.billMerge(args.data, callbackdata)
              render(viewmodel, newdata, true)
            }
          })
          vm.on('close', function () {
            viewmodel.communication({
              type: 'modal',
              payload: false
            })
          })
          viewmodel.communication({
            type: 'modal',
            payload: {
              type: 'platform',
              url: 'billmaker',
              model: viewmodel,
              data: {
                vm: vm,
                viewmeta: viewmeta
              }
            }
          })
        })

      })
    } else {
      let postData = {
        "billnum": billNo
      }
      let beforeActData = {
        params: params,
        data: postData
      };
      beforeAct(beforeActData, function () {
        common.emptyBill(postData, params, function (err, suc) {
          let afterActData = {
            err: err,
            res: suc
          }
          if (!err) {
            common.setMode(viewmodel, env.VOUCHER_STATE_ADD)
            viewmodel.addData = suc
            if (viewmodel.get(env.VOUCHER_TPL_KEY)) {
              let currentTpl = viewmodel.get(env.VOUCHER_TPL_KEY).getValue()
              suc[env.VOUCHER_TPL_KEY] = currentTpl
            }
            render(viewmodel, suc, true);
            // render(viewmodel, suc);
          }
          afterAct(afterActData, common.afterAct)

        })
      })

    }
  }

  const getPredicateValue = formatValue => {
    const exp = /<%.*?%>/g;
    const items = formatValue.match(exp);
    if (!items)
      return formatValue;
    const values = {};
    let valid = true;
    items.forEach(item => {
      const predicate = item.substring(2, item.length - 2).split('.');
      if (predicate.length !== 2) {
        valid = false;
        return;
      }
      const obj = cb.rest.AppContext[predicate[0]];
      values[item] = obj && (cb.utils.isEmpty(obj[predicate[1]]) ? '' : obj[predicate[1]]);
    });
    if (!valid)
      return formatValue;
    return formatValue.replace(exp, function (key) {
      return values[key];
    });
  }
  const localoutput = (billNo, viewmodel, params, beforeAct, afterAct) => {
    // const XLSX = require('xlsx');
    let outputData = viewmodel.get(`${params.childrenField}`).getData();
    let dataColumns = viewmodel.get(`${params.childrenField}`).getColumns();
    common.excelOutPut(outputData, [], dataColumns, `${billNo}.xlsx`, `${params.childrenField}`);
    return;
    let res = [];
    let tmpObj = {};
    //取每一行需要导出的数据
    for (let i = 0; i < outputData.length; i++) {
      let resObj = {};
      for (let key in dataColumns) {
        let keyName = dataColumns[key].cShowCaption ? dataColumns[key].cShowCaption : dataColumns[key].cCaption;
        if (dataColumns[key].bShowIt && !dataColumns[key].bHidden) {
          let resDetails = outputData[i];
          let resSonObj = {};
          resSonObj.cShowCaption = keyName;
          resSonObj.cControlType = dataColumns[key].cControlType;
          resSonObj.cFormatData = dataColumns[key].cFormatData;
          resSonObj.iNumPoint = dataColumns[key].iNumPoint;
          resSonObj.cEnumString = dataColumns[key].cEnumString;
          let enumValue = null;
          if (dataColumns[key].cEnumString) {
            let enumString = dataColumns[key].cEnumString;
            let lookupVector = Object.keys(eval("(" + enumString + ")"));
            let resultVector = Object.values(eval("(" + enumString + ")"));
            let thisLoc = lookupVector.indexOf(resDetails[key].toString());
            enumValue = resultVector[thisLoc];
          }
          resSonObj.iColWidth = dataColumns[key].iColWidth;
          tmpObj[key] = resSonObj;
          resObj[keyName] = enumValue ? enumValue : resDetails[key];
        }
      }
      res.push(resObj);
    }
    //导出文件的文件名
    let fileName = `${billNo}.xlsx`;
    let sheet = XLSX.utils.json_to_sheet(res);
    //行数(除header)
    let sheetRowCount = res.length;
    //列数
    let colCount = Object.keys(res[0]).length;
    sheet['!cols'] = new Array(colCount);
    let rowRange = XLSX.utils.decode_range(sheet['!ref']);
    for (let R = 0; R <= 1; ++R) {
      for (let C = rowRange.s.c; C <= rowRange.e.c; ++C) {
        if (R == 0) {
          let cell_address = { c: C, r: R };
          /* if an A1-style address is needed, encode the address */
          let cell_ref = XLSX.utils.encode_cell(cell_address);
          let value = sheet[cell_ref].v;
          for (let key in tmpObj) {
            if (tmpObj[key].cShowCaption === value) {
              let controlType = tmpObj[key].cControlType;
              let cellConfig = tmpObj[key];
              let cFormatData = cellConfig.cFormatData;
              sheet['!cols'][C] = { wpx: cellConfig.iColWidth };
              if (cFormatData === 'YYYY-MM-DD') {
                let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
                for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
                  let thisCell_address = { c: C, r: R };
                  let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
                  sheet[thisCell_ref].t = 'd';
                }
              }
              //枚举
              // let enumString = cellConfig.cEnumString;
              // if (enumString) {
              //   let lookupVector = Object.keys(eval("(" + enumString + ")"));
              //   let resultVector = Object.values(eval("(" + enumString + ")"));
              //   let strLookup = JSON.stringify(lookupVector).replace(/\[(.*)\]/, "$1");
              //   let strResult = JSON.stringify(resultVector).replace(/\[(.*)\]/, "$1");
              //   let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
              //   for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
              //     let thisCell_address = { c: C, r: R };
              //     let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
              //     let cellValue = sheet[thisCell_ref].v;
              //     // let thisLoc = lookupVector.indexOf(cellValue.toString());
              //     // sheet[thisCell_ref].v = resultVector[thisLoc];
              //     let func = `LOOKUP("${cellValue}",{${strLookup}},{${strResult}})`;
              //     sheet[thisCell_ref].f = func;
              //   }

              // }

              switch (controlType && controlType.trim().toLocaleLowerCase()) {
                case 'inputnumber':
                case 'money':
                case 'price':
                  try {
                    if (!cFormatData || cFormatData == '') {
                      cFormatData = {};
                    } else {
                      cFormatData = JSON.parse(cFormatData);
                    }
                  } catch (e) {
                    cb.utils.alert('数量/金额/单价，预制错误！', 'error');
                  }
                  let iNumPoint = cellConfig.iNumPoint;
                  let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
                  if (controlType === 'money') {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      iNumPoint = cb.rest.AppContext.option.amountofdecimal;
                  } else if (controlType === 'price') {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      iNumPoint = cb.rest.AppContext.option.monovalentdecimal;
                  } else {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      if (cb.utils.isEmpty(iNumPoint)) iNumPoint = null;
                  }
                  if (controlType === 'money' || (cFormatData.decimal && cFormatData.decimal.indexOf("amountofdecimal"))) {
                    cFormatData.splitter = true
                    //千分位处理(无小数位)
                    if (!iNumPoint) {
                      let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
                      for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
                        let thisCell_address = { c: C, r: R };
                        let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
                        sheet[thisCell_ref].z = XLSX.SSF._table[3];
                      }
                    }
                  }
                  if (iNumPoint) {
                    //小数位处理(有无千分位)
                    let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
                    for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
                      let thisCell_address = { c: C, r: R };
                      let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
                      let decimalCount = cFormatData.splitter ? "#,##0.0" : "0.0"
                      for (let i = 1; i < iNumPoint; i++) {
                        decimalCount = decimalCount + "0";
                      }
                      sheet[thisCell_ref].z = decimalCount;
                      sheet[thisCell_ref].t = 'n';
                    }
                  }
              }
            }
          }
        } else if (R === 1) {
          let cell_address = { c: C, r: R };
          /* if an A1-style address is needed, encode the address */
          let cell_ref = XLSX.utils.encode_cell(cell_address);
          if (sheet[cell_ref].t === 'n') {
            let length = sheet[cell_ref].v.toString().length;
            if (sheet[cell_ref].z) {
              let re = /[0-9]+\.([0-9]*)/;
              //小数位数
              let deciLength = sheet[cell_ref].v.toString().replace(re, "$1").length;
              length = length + deciLength;
            } else if (length >= 12) {
              //解决科学计数法
              let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
              for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
                let thisCell_address = { c: C, r: R };
                let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
                sheet[thisCell_ref].z = XLSX.SSF._table[1];
              }
            }
          } else if (sheet[cell_ref].t === 'b') {
            let colRange = { s: { r: 1, c: C }, e: { r: sheetRowCount, c: C } };
            for (let R = colRange.s.r; R <= colRange.e.r; ++R) {
              let thisCell_address = { c: C, r: R };
              let thisCell_ref = XLSX.utils.encode_cell(thisCell_address);
              sheet[thisCell_ref].t = 's';
              sheet[thisCell_ref].v = sheet[thisCell_ref].v ? "是" : "否";
              // sheet[thisCell_ref].f = `IF(${sheet[thisCell_ref].v},"是","否")`;
            }
          }
        }
      }
    }
    let wb = XLSX.utils.book_new();
    //wb中增加一个sheet
    XLSX.utils.book_append_sheet(wb, sheet, `${params.childrenField}`);
    // 导出 Excel
    XLSX.writeFile(wb, fileName);
  }
  const output = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let printID = viewmodel.get(env.VOUCHER_PRINT_KEY) && viewmodel.get(env.VOUCHER_PRINT_KEY).getValue() && viewmodel.get(env.VOUCHER_PRINT_KEY).getValue().toString()
    let queryString = new cb.utils.queryString("/files" + params.cSvcUrl)
    if (!queryString) {
      return
    }
    let format = queryString.has('type') ? queryString.get('type') : 'pdf'
    let inputParams = {
      // bill: {
      billnum: billNo,
      ids: [viewmodel.get('id').getValue()].join(),
      id: viewmodel.get('id').getValue(),
      data: params.data,
      partParam: params.partParam
      //   tplid: printID
      // },
      // type: 'voucher',
      // format: format
    }
    queryString.set('token', cb.rest.AppContext.token || '')
    let url = queryString && queryString.pathname + queryString.toStr()

    let beforeActData = {
      params: params,
      data: inputParams
    };
    beforeAct(beforeActData, function () {
      common.createDownloadForm(url, inputParams)
      afterAct()
    })

  }

  const savebo = (billNo, viewmodel, params, beforeAct, afterAct) => {
    const proxy = cb.rest.DynamicProxy.create({
      saveBo: { url: 'print/saveBo', method: 'GET' }
    })
    proxy.saveBo({ billno: billNo }, function (err, result) {
      if (err) {
        cb.utils.alert(err.message, 'error');
        return;
      }
      cb.utils.alert('保存业务对象成功', 'success');
    });
  }

  const preview = (billNo, viewmodel, params, beforeAct, afterAct) => {
    const actionName = params.params && params.params.cAction;
    if (actionName === 'localPrint') {
      const localPrintButtonModel = viewmodel.get('btnLocalPrint');
      if (localPrintButtonModel) {
        params.disabledCallback = function () {
          localPrintButtonModel.setDisabled(true);
        }
        params.enabledCallback = function () {
          localPrintButtonModel.setDisabled(false);
        }
      }
      viewmodel.biz.do(actionName, viewmodel, params);
      return;
    }
    beforeAct({ params }, function () {
      const template = viewmodel.get('templates').getValue();
      if (!template) {
        cb.utils.alert('请选择打印模板', 'warning');
        return;
      }
      const proxy1 = cb.rest.DynamicProxy.create({
        preview: { url: 'print/printPreview', method: 'POST', options: { async: false } }
      })
      const data = proxy1.preview({
        route: params.cSvcUrl || '/bill',
        billno: billNo,
        template: template,
        ids: [viewmodel.get('id').getValue()]
      });
      if (!data.error) {
        // window.open(cb.electron.getSharedObject() ? '/print/touch?src=' + encodeURIComponent(data.result) : data.result);
        if (cb.electron.getSharedObject()) {
          const { serviceUrl, token } = cb.rest.AppContext;
          cb.electron.sendOrder('openExternal', `${serviceUrl}${data.result}&token=${token}`);
        } else {
          window.open(data.result);
        }
      }
      const afterActData = {
        err: data.error,
        res: data.result
      };
      afterAct(afterActData, common.afterAct);
      return;
      const newTab = window.open('about:blank');
      const proxy = cb.rest.DynamicProxy.create({
        preview: { url: 'print/printPreview', method: 'POST' }
      })
      proxy.preview({
        route: params.cSvcUrl || '/bill',
        billno: billNo,
        template: template,
        ids: [viewmodel.get('id').getValue()]
      }, function (err, result) {
        if (!err)
          newTab.location.href = result;
        const afterActData = {
          err: err,
          res: result
        };
        afterAct(afterActData, common.afterAct);
      });
    });
  }

  const print = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let printID = viewmodel.get(env.VOUCHER_PRINT_KEY) && viewmodel.get(env.VOUCHER_PRINT_KEY).getValue() && viewmodel.get(env.VOUCHER_PRINT_KEY).getValue().toString()
    let postData = {
      json: {
        bill: {
          billnum: billNo,
          ids: [viewmodel.get('id').getValue()],
          tplid: printID
        },
        type: 'voucher'
      }
    }

    let beforeActData = {
      params: params,
      data: postData
    };
    beforeAct(beforeActData, function () {
      let callback = function (err, result) {
        if (err) {
          console.error(err)
          return
        }
        window.open(result)
        afterAct()
      }
      common.doPrint(postData, params, callback)
    })


  }

  const initDefaultActions = (billNo, viewmodel, params, beforeAct, afterAct) => {
    let allActions = viewmodel.allActions
    let beforeActData = {
      params: params,
      data: allActions
    };
    beforeAct(beforeActData, function () {
      viewmodel.on('moveprev', function () {
        let prevAction = allActions.find((x) => {
          return x.cCommand && x.cCommand.trim().toLocaleLowerCase() === 'cmdmoveprev'
        })
        if (prevAction) {
          movePrevOrNext(billNo, viewmodel, prevAction)
        }
      })
      viewmodel.on('movenext', function () {
        let nextAction = allActions.find((x) => {
          return x.cCommand && x.cCommand.trim().toLocaleLowerCase() === 'cmdmovenext'
        })
        if (nextAction) {
          movePrevOrNext(billNo, viewmodel, nextAction)
        }
      })
      if (viewmodel.get(env.VOUCHER_TPL_KEY)) {
        viewmodel.get(env.VOUCHER_TPL_KEY).on('afterValueChange', function (data) {
          if (data && data.value) {
            viewmodel.biz.do('selecttpl', viewmodel, data)
          }
        })
      }
      afterAct()
    })

  }

  const selectTpl = function (billNo, oldVM, params, beforeAct, afterAct) {
    params.tplid = params['value'].value
    let cbk = (err, result, ) => {
      const vmAndView = common.initVM(err, result, billNo, params)
      if (vmAndView) {
        let { vm: newVM, view: newView } = vmAndView
        oldVM.communication({
          payload: {
            menuName: newView.cBillName,
            vm: newVM,
            refresh: true,
            metaData: newView
          }
        })
        _loadVm(oldVM, newVM)
        common.setMode(newVM, common.getMode(oldVM))
        let loadData,
          setData
        if (common.getMode(newVM) == env.VOUCHER_STATE_ADD) {
          loadData = oldVM.collectData(true)
          setData = oldVM.addData
        } else {
          loadData = oldVM.getOriginalData()
          setData = oldVM.collectData(true)
        }
        newVM.setData(setData)
        render(newVM, loadData, common.getMode(newVM) == env.VOUCHER_STATE_ADD)

        if (afterAct) afterAct()
      }
    }
    let beforeActData = {
      params: params,
    };
    beforeAct(beforeActData, function () {

      common.fetchMeta(billNo, params, cbk)
    })
  }

  const push = function (billNo, viewModel, params, beforeAct, afterAct) {
    if (viewModel) {
      common.push(viewModel, params, viewModel.collectData(true), beforeAct, afterAct);
      return;
    }
    if (!params || !params.cSvcUrl) return;
    const queryString = new cb.utils.queryString(params.cSvcUrl);
    const groupCode = queryString.get('groupCode'); const targetCode = queryString.get('code');
    if (!targetCode) return;
    const callback = function (err, pushData) {
      if (err) {
        if (window.parent !== window && cb.rest.AppContext.query.random)
          window.parent.postMessage({ key: 'crossdomainpush', random: cb.rest.AppContext.query.random, args: err.message }, '*');
        else
          common.afterAct({ err });
        return;
      }
      if (window.parent !== window && cb.rest.AppContext.query.random)
        window.parent.postMessage({ key: 'crossdomainpush', random: cb.rest.AppContext.query.random }, '*');
      if (!pushData.targetData) return;
      // fangqg: 默认新增，加上状态值会认为是假新增
      delete pushData.targetData._status;
      params.carryParams = params.carryParams || {};
      params.carryParams.externalData = pushData.targetData;
      params.targetData = pushData.targetData;
      /* 肖静说  一条数据直接进单据 */
      if (pushData.dimensionKeys && pushData.dimensionKeys.length > 1)
        params.dimensionKeys = pushData.dimensionKeys;
      params.dimensionGroupCode = groupCode;
      params.groupTaskKey = pushData.dimensionKeys && pushData.dimensionKeys.length && pushData.dimensionKeys[0].groupTaskKey;
      params.bWorkbench = !!groupCode;
      pushData.targetData.dimensionKey = pushData.dimensionKeys && pushData.dimensionKeys[0] && pushData.dimensionKeys[0].key
      _getInitdata(billNo, params, function (err1, emptyData) {
        if (err1) {
          common.afterAct({ err1 });
          return;
        }
        afterAct(null, common.billMerge(emptyData, pushData.targetData));
      });
    };
    if (!cb.utils.isArray(params.data))
      params.data = [params.data];
    const ids = []; const detailIds = [];
    params.data.forEach(item => {
      ids.push(item.id);
      if (params.pushKey)
        detailIds.push(item[params.pushKey]);
    });
    const childIds = params.pushKey ? detailIds : [...new Set(ids)];
    const mainIds = params.pushKey ? [...new Set(ids)] : undefined;
    const postData = {
      code: targetCode,
      isMainSelect: params.pushKey ? 0 : 1,
      childIds,
      mainIds,
      data: params.data,
      groupCode: groupCode
    };
    Object.assign(postData, params.carryParams);
    common.doProxy(params, callback, postData);
  }

  const compositeAction = (billNo, viewModel, params) => {
    let firstAction = null;
    let Act = null;
    try {
      const defineParams = JSON.parse(params.cmdParameter);
      firstAction = defineParams.action.split('&')[0].replace(/(\w)/, function (v) {
        return v.toUpperCase()
      });
      Act = viewModel.biz.action()[firstAction.trim().toLocaleLowerCase()];
      if (!Act) return;
      params.defineParams = defineParams;
    } catch (e) {
      console.error('compositeAction error: ' + e.message);
      return;
    }
    const beforeAct = (beforeActData, callback) => {
      viewModel.promiseExecute('before' + firstAction, beforeActData, callback);
    };
    const afterAct = (afterActData, callback) => {
      viewModel.promiseExecute('after' + firstAction, afterActData, function () {
        callback && callback(afterActData);
      });
    };
    Act(billNo, viewModel, params, beforeAct, afterAct, params.cShowCaption);
  }
  const batchModify = (billNo, viewmodel, params, beforeAct, afterAct) => {
    viewmodel.communication({
      type: 'modal',
      payload: {
        key: 'batchModify',
        data: {
          billType: "voucher",
          billNo: billNo,
          model: viewmodel,
          params: params
        }
      }
    });
  }
  const saveDraft = (billNo, viewModel, params, beforeAct, afterAct) => {
    viewModel.communication({
      type: 'modal',
      payload: {
        key: 'Savedraft',
        data: {
          model: viewModel
        }
      }
    });
  }

  return {
    init: function (billNo, params, viewCallback) {
      params = params || {};
      if (!params.mode && params.query && params.query.mode)
        params.mode = params.query.mode;
      if (!params.id && params.query && params.query.id)
        params.id = params.query.id;
      let self = this
      let initDataCallback = function (err, billData) {
        if (!err) {
          const { cardViewModel } = params;
          if (cardViewModel) {
            cardViewModel.biz.do('load', cardViewModel, {
              data: billData
            });
            cb.utils.loadingControl.end();
            return;
          }
          let vmParams = Object.assign({}, params)
          if (billData && billData.tplid && params && !params.tplid) {
            vmParams.tplid = billData.tplid
          }
          if (params && params.carryData) {
            billData = Object.assign(billData, params.carryData)
          }
          let cbk = function (err, meta) {
            vmParams.billData = billData
            if (billData && billData['_status'] === cb.models.DataStates.Insert)
              vmParams.mode = env.VOUCHER_STATE_ADD;
            _fetchMetaCallback(err, meta, billNo, viewCallback, vmParams)
          }
          common.fetchMeta(billNo, vmParams, cbk)
        } else {
          common.afterAct({
            err: err
          })
        }
      }
      if (params && params.metatype == 'editablevoucherlist') { //只有一个可编辑的列表,不获取数据直接加载页面
        initDataCallback()
      } else {
        // _getInitdata(billNo, params, initDataCallback)
        const proxy = cb.rest.DynamicProxy.create({ getTplList: { url: 'billmeta/tpllist', method: 'GET' } });
        proxy.getTplList({ billno: billNo }, function (err, result) {
          if (err || result.length === 1) {
            params.tplid = result && result[0].iTplId;
            if (params.action)
              return self.action()[params.action](billNo, null, params, function () { }, initDataCallback);
            _getInitdata(billNo, params, initDataCallback);
            return;
          }
          const tpllist = {};
          result.forEach(function (tpl) {
            const tplid = tpl.iTplId;
            switch (tpl.iTplMode) {
              case 0:
                tpllist[env.VOUCHER_STATE_BROWSE] = tplid;
                break;
              case 2:
                tpllist[env.VOUCHER_STATE_EDIT] = tplid;
            }
          });
          params.multitpl = true;
          params.tplid = params.mode === 'browse' || params.readOnly ? tpllist[env.VOUCHER_STATE_BROWSE] : tpllist[env.VOUCHER_STATE_EDIT];
          if (params.action)
            return self.action()[params.action](billNo, null, params, function () { }, initDataCallback);
          _getInitdata(billNo, params, initDataCallback);
        });
      }

    },
    do: function (act, viewmodel, params) {
      common.todo(this, act, viewmodel, params)
    },
    action: function () {
      let voucherAction = {
        render: renderData,
        doservice: _doService,
        load: loadData,
        rule: buildRule,
        initdefaultactions: initDefaultActions,
        commandline: common.commandLine,
        abandon: abandon,
        copy: copy,
        push: push,
        edit: common.edit,
        save: save,
        addrow: addRow,
        table2dbtnclick: table2DBtnClick,
        insertrow: insertRow,
        deleterow: deleteRow,
        copyrow: copyRow,
        shiftuprow: shiftUpRow,
        shiftdownrow: shiftDownRow,
        delete: doDelete,
        invalid: inValid,
        audit: audit,
        submit: submit,
        unaudit: audit,
        close: close,
        open: close,
        movefirst: moveFirstOrLast,
        movelast: moveFirstOrLast,
        moveprev: movePrevOrNext,
        movenext: movePrevOrNext,
        add: add,
        create: add,
        pull: pull,
        check: common.check,
        refresh: refresh,
        columnsetting: common.columnsetting,
        checkapprove: checkApprove,
        cellcheck: cellCheck,
        lineopen: lineOpenOrClose,
        lineclose: lineOpenOrClose,
        localoutput: localoutput,
        output: output,
        print: print,
        selecttpl: selectTpl,
        saveandadd: saveAndAdd,
        saveandaudit: saveAndAudit,
        savebo: savebo,
        preview: preview,
        localprint: localPrint,
        selfdefineaction: compositeAction,
        savedraft: saveDraft,
        batchmodify: batchModify
      }
      return Object.assign(voucherAction, mVoucher);
    }
  }
}()

cb.namespace('biz.common')
cb.biz.common.voucher = voucher

export default voucher



// WEBPACK FOOTER //
// ./src/yxyweb/client/common/voucher.js